
import * as types from './types';
import { JSON_STRING, HttpClient } from '../../../../services/http/http-client';
import { NoticesService } from '../../services/notices.service';
import router from '../../../../router';
import { setNavigationTabs, getTabsFromDetailsDict, handleCloseTabRoute, setDetailsObject, implementDeleteNavTabAction, implementSetAllNavTabDetailsAction, getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';
import { htmlToString, matchHead } from '../../../../utility';
import { setMainNavInactive } from '../../../../store/app/mutations';

// Action Object for NoticesSettings. Import the types from notices/types.js and Invoke Actions from the Vuex Host Components.
const NavTabModule = getNavTabModule(types.NoticesDetails, 'noticesDetails');

export const noticesSettingsActions = {
  async [types.NoticesSettingsData.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const noticesSettingsData = await HttpClient.mergeRequests([
      NoticesService.findNotices(),
    ]);
    console.log(noticesSettingsData);
    commit(types.NoticesSettingsData.SET.ALL, noticesSettingsData);
  },

  // async [types.NoticesDetails.SET.ALL]({ getters, commit, rootState }, payload) {
  //   commit(types.NoticesDetails.SET.ALL, payload);

  //   setNavigationTabs(commit, rootState, 'settings', 'notices', getTabsFromDetailsDict(getters.noticesDetails,
  //     (value, key) => {
  //       return {
  //         title: value?.notice ? htmlToString(value.notice) : key,
  //         full_title: value?.notice ? htmlToString(value.notice) : key,
  //       }
  //     }));
  // },
  async [types.NoticesDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters)

    let { flag, notice } = payload;

    setMainNavInactive(commit, flag);

    // console.log("Log: noticeDetails", notice, payload)
    const { client_notice_id } = notice || {};

    if (!notice?.notice) {
      notice = getters?.noticesSettingsData?.notices?.find(e => e?.client_notice_id == client_notice_id);
      if (!notice) {
        return;
      }
    }


    // dispatch(types.NoticesDetails.SET.ALL, {
    //   ...getters.noticesDetails,
    //   [client_notice_id]: notice
    // });

    NavTabHelper.setSingleNavTabDetails(client_notice_id, () => notice);

    console.log(getters.noticesDetails);

  },

  // ...implementSetAllNavTabDetailsAction(types.NoticesDetails, 
  //   'settings', 'notices', 'noticesDetails',
  //   (value, key) => {
  //     return {
  //       title: value?.notice ? htmlToString(value.notice) : key,
  //       full_title: value?.notice ? htmlToString(value.notice) : key,
  //     }
  //   }
  // ),
  // ...implementDeleteNavTabAction(
  //   types.NoticesDetails,
  //   'noticesDetails',
  //   'client_notice_id',
  //   'notices/client_notice_id',
  //   'notices',
  //   () => router
  // ),

  ...NavTabModule.implementActions(
    'client_notice_id',
    'notices/client_notice_id',
    'notices',
    () => router,
    'settings',
    (value, key) => {
      return {
        title: value?.notice ? htmlToString(value.notice) : key,
        full_title: value?.notice ? htmlToString(value.notice) : key,
      }
    }
  ),

  // async [types.NoticesDetails.DELETE.SINGLE]({ dispatch, getters }, payload) {
  //   const { client_notice_id } = payload;

  //   // dispatch(types.NoticesDetails.SET.ALL, {
  //   //   ...getters.noticesDetails,
  //   //   [client_notice_id]: undefined
  //   // });
  //   console.log({dispatch, NoticesDetails: types.NoticesDetails, getters, noticeDetails: 'noticeDetails', client_notice_id});
  //   setDetailsObject(dispatch, types.NoticesDetails, getters, 'noticesDetails', client_notice_id);
  //   handleCloseTabRoute('notices/client_notice_id', 'notices', 'client_notice_id', client_notice_id, router);

  //   // if (matchHead('notices/client_notice_id', router.currentRoute.name)) {
  //   //   if (router.currentRoute.params.client_notice_id == client_notice_id) {
  //   //     router.push({
  //   //       name: 'notices'
  //   //     });
  //   //   }
  //   // }
  // },
}
